export default function Dashboard() {
  return (
    <div className="h-full overflow-y-auto max-w-7xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Placeholder cards for features */}
        <div className="bg-gray-800 rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-2">Radio Status</h2>
          <p className="text-gray-400">Online: 0 / Offline: 0</p>
        </div>
        <div className="bg-gray-800 rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-2">Active Calls</h2>
          <p className="text-gray-400">0 active transmissions</p>
        </div>
        <div className="bg-gray-800 rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-2">Channels</h2>
          <p className="text-gray-400">0 channels configured</p>
        </div>
      </div>

      {/* Phase 6 placeholders */}
      <section className="mt-8">
        <h2 className="text-2xl font-bold mb-4">Management Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-gray-800 rounded-lg p-4">
            <h3 className="font-semibold mb-2">📡 Radios & Devices</h3>
            <p className="text-gray-400">Add, edit, and manage radio units</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <h3 className="font-semibold mb-2">📢 Channels</h3>
            <p className="text-gray-400">Create and configure talk groups</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <h3 className="font-semibold mb-2">👥 Users</h3>
            <p className="text-gray-400">Manage admin and dispatcher accounts</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <h3 className="font-semibold mb-2">🔑 Provisioning</h3>
            <p className="text-gray-400">Generate enrollment tokens for radios</p>
          </div>
        </div>
      </section>

      <div className="mt-8 text-center">
        <p className="text-gray-400">
          Complete system administration through the Admin panel. Click the ⚙️ Admin button to manage your fleet.
        </p>
      </div>
    </div>
  )
}
